import CancelSvg from './cancel.svg'
import CheckCircleSvg from './check-circle.svg'
import CheckboxCircleSvg from './checkboxCircle.svg'
import Logo001Svg from './logo001.svg'
import Logo002Svg from './logo002.svg'
import Logo003Svg from './logo003.svg'
import LogoFacebookComponent from './logoFacebook.svg'
import LogoInstagramComponent from './logoInstagram.svg'
import LogoLinkedInComponent from './logoLinkedIn.svg'
import StripedCircleSvg from './striped-circle.svg'
import TaskAltSvg from './taskAlt.svg'

export {
  CancelSvg,
  CheckboxCircleSvg,
  CheckCircleSvg,
  Logo001Svg,
  Logo002Svg,
  Logo003Svg,
  LogoFacebookComponent,
  LogoInstagramComponent,
  LogoLinkedInComponent,
  StripedCircleSvg,
  TaskAltSvg,
}
